import {PAYMENTS} from 'desktop/pages/checkout/constants/paymentStep';
import {AddressType} from 'desktop/types/addressType';

/**
 *  add Keys In Params
 */
export const addKeysInParams = ({
    country,
    name,
    postalCode,
    regionId,
    shippingAddress,
}: {
    country: string;
    shippingAddress: AddressType;
    regionId: string;
    postalCode: string;
    name: string;
}) => {
    const params: {[key: string]: string | number} = {
        country: country || shippingAddress?.country?.value,
    };

    if (params.country === 'US') {
        params.region_id = regionId;

        if (shippingAddress?.postal?.value) {
            params.postcode = shippingAddress.postal.value;
        }
    }

    if (name === PAYMENTS.METHOD_AMAZON_V2 && postalCode) {
        params.postcode = postalCode;
    }

    return params;
};
